"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletePipelineRelation = exports.postPipelineRelation = exports.putPipelineOrganization = exports.putPipelineAccessibility = exports.deletePipelinePermission = exports.postPipelinePermission = exports.delPipeline = exports.postPipeline = exports.putPipeline = exports.getPipeline = exports.getPipelines = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var path = root_1.crmAuthorized + '/pipelines/';

var getPipelines = function getPipelines(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getPipelines = getPipelines;

var getPipeline = function getPipeline(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getPipeline = getPipeline;

var putPipeline = function putPipeline(authentication, pipeline) {
  return common_1.put(authentication, path + pipeline.id, pipeline);
};

exports.putPipeline = putPipeline;

var postPipeline = function postPipeline(authentication, pipeline) {
  return common_1.post(authentication, path, pipeline);
};

exports.postPipeline = postPipeline;

var delPipeline = function delPipeline(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delPipeline = delPipeline;

var postPipelinePermission = function postPipelinePermission(authentication, id, permission) {
  return common_1.postPermission(authentication, path, id, permission);
};

exports.postPipelinePermission = postPipelinePermission;

var deletePipelinePermission = function deletePipelinePermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, path, id, permissionId);
};

exports.deletePipelinePermission = deletePipelinePermission;

var putPipelineAccessibility = function putPipelineAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, path, id, accessibility);
};

exports.putPipelineAccessibility = putPipelineAccessibility;

var putPipelineOrganization = function putPipelineOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, path, id, organizationId);
};

exports.putPipelineOrganization = putPipelineOrganization;

var postPipelineRelation = function postPipelineRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postPipelineRelation = postPipelineRelation;

var deletePipelineRelation = function deletePipelineRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deletePipelineRelation = deletePipelineRelation;